import { TrelloServiceComponent } from './TrelloServiceComponent';
export const TrelloReconnectionConfig = {
  reconnectButton: null,
  serviceComponent: TrelloServiceComponent
};